// "Production" enabled environment

export const environment = {
    production: true,
    hmr: false,
    appConfig: 'appconfig.production.json',
    appInsights:{
        instrumentationKey:'fe885112-09bc-45e7-b080-6e0be715def8',
        isenable:false
    }
};
